import postsJson from '../content/posts.json';
import type { ChangelogPost } from './types';

const posts = postsJson as ChangelogPost[];

const getAllChangelogPosts = (): ChangelogPost[] => posts;

const getChangelogPost = (slug: string): ChangelogPost | undefined => posts.find(post => post.slug === slug);

export type { ChangelogPost };
export { getAllChangelogPosts, getChangelogPost };
